module.exports = __webpack_public_path__ + "img/logo.d8dcf49a.png";